/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalImportGetInstancesResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'any[]',
        isRequired: true,
      },
    },
  }],
} as const;
